var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-group-label",attrs:{"for":_vm.labelFor}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.convertedLabel)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }